export const BACKEND = (() => {
  if (process.env.REACT_APP_STAGE === 'development') return 'http://localhost:5011';
  return 'https://services.xbot.com.vn:1254';
})();

export const RESOURCES = 'https://services.xbot.com.vn:1251';
